const STAGING_PREFIXES = ["dev", "qa", "uat", "staging"];

export type AppUiStage = "local" | "dev" | "staging" | "prod";

export type UiStageEndpoint = { [k in AppUiStage]: object };
export class Environment {
  static DEFAULT_ENDPOINTS: UiStageEndpoint = {
    local: {
      baseUrl: "https://api-leaderboard.dev.svcs.ferrumnetwork.io",
      crucibleBaseUrl:
        "https://hpy3si6t8i.execute-api.us-east-2.amazonaws.com/default/crucible-arbitrum-staging/", // “https://crucible-backend.dev.svcs.ferrumnetwork.io/”,
      fiberBaseUrl: "https://api-fiber-engine.dev.svcs.ferrumnetwork.io",
      forgeBaseUrl: "https://api-forge.dev.svcs.ferrumnetwork.io",
      snapHodlBaseUrl: "https://snap-hodl-backend-prod.svcs.ferrumnetwork.io",
      coinGeckoBaseUrl: "https://api.coingecko.com",
    },
    dev: {
      baseUrl: "https://api-leaderboard.dev.svcs.ferrumnetwork.io",
      crucibleBaseUrl:
        "https://hpy3si6t8i.execute-api.us-east-2.amazonaws.com/default/crucible-arbitrum-staging/",
      fiberBaseUrl: "https://api-fiber-engine.dev.svcs.ferrumnetwork.io",
      forgeBaseUrl: "https://api-forge.dev.svcs.ferrumnetwork.io",
      snapHodlBaseUrl: "https://snap-hodl-backend-prod.svcs.ferrumnetwork.io",
      // crucibleBaseUrl: "https://xxda22hwpy.us-east-2.awsapprunner.com/"
      coinGeckoBaseUrl: "https://api.coingecko.com",
    },
    staging: {
      baseUrl: "https://api-leaderboard.dev.svcs.ferrumnetwork.io",
      crucibleBaseUrl: "https://22phwrgczz.us-east-2.awsapprunner.com/",
      fiberBaseUrl: "",
      forgeBaseUrl: "https://api-forge.dev.svcs.ferrumnetwork.io",
      snapHodlBaseUrl: "https://snap-hodl-backend-prod.svcs.ferrumnetwork.io",
      coinGeckoBaseUrl: "https://api.coingecko.com",
    },
    prod: {
      baseUrl: "https://api-leaderboard.dev.svcs.ferrumnetwork.io",
      crucibleBaseUrl: "https://22phwrgczz.us-east-2.awsapprunner.com/",
      fiberBaseUrl: "https://api-fiber-engine.dev.svcs.ferrumnetwork.io",
      forgeBaseUrl: "https://api-forge.dev.svcs.ferrumnetwork.io",
      snapHodlBaseUrl: "https://snap-hodl-backend-prod.svcs.ferrumnetwork.io",
      coinGeckoBaseUrl: "https://api.coingecko.com",
    },
  };

  static uiStage(): AppUiStage {
    // console.log(process.env.OVERRIDE_UI_STAGE)
    if (!!process.env.OVERRIDE_UI_STAGE) {
      return process.env.OVERRIDE_UI_STAGE as any;
    }
    const base = (window.location?.origin || "").toLowerCase();
    // console.log(base)
    // console.log(process.env.NODE_ENV)
    const isCompiled = process.env.NODE_ENV === "production";
    if (!isCompiled) {
      // console.log('local')
      return "local";
    }
    const prefix = STAGING_PREFIXES.find((p) =>
      base.includes(`-${p}` || `https://${p}`)
    );
    if (prefix) {
      // console.log(prefix,'current-prefix')
      return prefix as AppUiStage;
    }
    // console.log('prod')
    return "prod";
  }

  static defaultEndPoint(): object {
    const ep = Environment.DEFAULT_ENDPOINTS[Environment.uiStage()];
    // console.log(ep)
    return ep!;
  }
}
